var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.header.computed),function(prop){return _c('span',{key:prop},[_vm._v(_vm._s(_vm.item[prop])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }